














































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { InputCodeAddress } from '@/components/molecules/InputCodeAddress'
import { orderBy } from 'lodash'
import { defaultSystemCodeAddress, SystemCodeAddress } from '@/api'
import { SortOrder, UserDetailStateInfo } from '@/types'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'descNo',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    items: [
      {
        name: 'addressCode',
        headerText: '住所コード',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '80',
    items: [
      {
        name: 'address',
        headerText: '住所',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

export interface UserOldAddressTableItem {
  id: number
  addressCode: {
    input: SystemCodeAddress
    errorMessage: string
  }
  address: {
    input: string
    errorMessage: string
  }
}

const defaultUserOldAddressTableItem = (): UserOldAddressTableItem => ({
  id: 0,
  addressCode: {
    input: defaultSystemCodeAddress(),
    errorMessage: ''
  },
  address: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    DataTable,
    InputCodeAddress
  }
})
export default class UserOldAddressTable extends ComponentVue {
  @PropSync('items', {
    type: Array,
    required: true
  })
  inputItems!: UserOldAddressTableItem[]

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get sortedInputItems(): UserOldAddressTableItem[] {
    if (this.sortName) {
      return orderBy<UserOldAddressTableItem>(
        this.inputItems,
        (item: UserOldAddressTableItem) => {
          switch (this.sortName) {
            case 'addressCode':
              return item.addressCode.input.code
            case 'address':
              return item.address.input
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.inputItems
  }

  get allCols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return COLS.map(col => {
        return {
          width: col.width,
          items: col.items.map(item => {
            return {
              name: item.name,
              headerText: item.headerText,
              align: item.align,
              sortable: false,
              sortOrder: item.sortOrder,
              lineFeed: item.lineFeed
            }
          })
        }
      })
    }

    return COLS
  }

  get cols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  @Watch('state.state')
  onChangeState(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  add(): void {
    this.inputItems.unshift(defaultUserOldAddressTableItem())
  }

  remove(index: number): void {
    this.inputItems.splice(index, 1)
  }

  inputAddressCode(index: number, systemCodeAddress: SystemCodeAddress): void {
    this.inputItems[index].addressCode.input = systemCodeAddress
    this.inputItems[index].address.input = systemCodeAddress.name
    this.resetErrorMessage(this.inputItems[index].addressCode)
    this.resetErrorMessage(this.inputItems[index].address)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
